module.exports = __webpack_public_path__ + "static/media/emptyFilters.30f74fe0.png";